import UsersGrid from "./users-grid";

export default UsersGrid;